module.exports = __webpack_public_path__ + "media/explode.64090978.mp3";